package co.maytes.standupbot.dashboard.features.releases

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.B
import org.jetbrains.compose.web.dom.Code
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Em
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.H4
import org.jetbrains.compose.web.dom.H5
import org.jetbrains.compose.web.dom.Hr
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Pre
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul

internal object MarkdownClasses {
    const val ROOT = "sb-md"
    const val CODE = "sb-md-code"
    const val PRE = "sb-md-pre"
    const val QUOTE = "sb-md-quote"
    const val LINK = "sb-md-link"
}

@Composable
fun ReleaseMarkdownView(source: String) {
    val blocks = ReleaseMarkdown.parse(source)
    Div(attrs = { classes(MarkdownClasses.ROOT) }) { blocks.forEach { MarkdownBlock(it) } }
}

@Composable
private fun MarkdownBlock(block: MdBlock) {
    when (block) {
        is MdBlock.Heading ->
            when (block.level) {
                1, 2 -> H3 { MarkdownInlines(block.content) }
                3 -> H4 { MarkdownInlines(block.content) }
                else -> H5 { MarkdownInlines(block.content) }
            }
        is MdBlock.Paragraph -> P { MarkdownInlines(block.content) }
        is MdBlock.Quote -> Div(attrs = { classes(MarkdownClasses.QUOTE) }) { MarkdownInlines(block.content) }
        is MdBlock.CodeBlock -> Pre(attrs = { classes(MarkdownClasses.PRE) }) { Code { Text(block.code) } }
        is MdBlock.ListBlock -> MarkdownList(block)
        MdBlock.Rule -> Hr()
    }
}

@Composable
private fun MarkdownList(block: MdBlock.ListBlock) {
    val items: @Composable () -> Unit = {
        block.items.forEach { item ->
            Li {
                MarkdownInlines(item.content)
                item.children.forEach { MarkdownList(it) }
            }
        }
    }
    if (block.ordered) Ol { items() } else Ul { items() }
}

@Composable
private fun MarkdownInlines(content: List<MdInline>) {
    content.forEach { inline ->
        when (inline) {
            is MdInline.Text -> Text(inline.value)
            is MdInline.Code -> Code(attrs = { classes(MarkdownClasses.CODE) }) { Text(inline.value) }
            is MdInline.Bold -> B { MarkdownInlines(inline.children) }
            is MdInline.Italic -> Em { MarkdownInlines(inline.children) }
            is MdInline.Link -> {
                val href = ReleaseMarkdown.safeHref(inline.href)
                if (href == null) {
                    Span { MarkdownInlines(inline.label) }
                } else {
                    A(
                        href = href,
                        attrs = {
                            classes(MarkdownClasses.LINK)
                            attr("target", "_blank")
                            attr("rel", "noopener noreferrer")
                        },
                    ) { MarkdownInlines(inline.label) }
                }
            }
        }
    }
}
